import { AlbumsQueryParams } from '@adminServices';
import { computed, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CreateAlbumDto, UpdateAlbumDto } from '@klubovna/api-client';
import { Store } from '@ngrx/store';
import * as AlbumsActions from './albums.actions';
import * as AlbumsSelectors from './albums.selectors';

@Injectable({
  providedIn: 'root',
})
export class AlbumsFacade {
  private store = inject(Store);

  albums$ = this.store.select(AlbumsSelectors.selectAllAlbums);
  loading$ = this.store.select(AlbumsSelectors.selectAlbumsLoading);
  error$ = this.store.select(AlbumsSelectors.selectAlbumsError);
  pagination$ = this.store.select(AlbumsSelectors.selectAlbumsPagination);

  albums = toSignal(this.albums$, { initialValue: [] });
  loading = toSignal(this.loading$, { initialValue: false });

  filteredAlbums = computed(() => {
    return this.albums();
  });

  loadAlbums(params?: AlbumsQueryParams): void {
    this.store.dispatch(AlbumsActions.loadAlbums({ params }));
  }

  loadAlbum(id: string): void {
    this.store.dispatch(AlbumsActions.loadAlbum({ id }));
  }

  createAlbum(albumData: CreateAlbumDto): void {
    this.store.dispatch(AlbumsActions.createAlbum({ albumData }));
  }

  updateAlbum(id: string, albumData: UpdateAlbumDto): void {
    this.store.dispatch(AlbumsActions.updateAlbum({ id, albumData }));
  }

  deleteAlbum(id: string): void {
    this.store.dispatch(AlbumsActions.deleteAlbum({ id }));
  }

  uploadPhotos(id: string, files: File[]): void {
    this.store.dispatch(AlbumsActions.uploadPhotos({ id, files }));
  }

  deletePhoto(id: string, photoId: string): void {
    this.store.dispatch(AlbumsActions.deletePhoto({ id, photoId }));
  }

  setTitlePhoto(id: string, photoId: string): void {
    this.store.dispatch(AlbumsActions.setTitlePhoto({ id, photoId }));
  }
}

